export default __webpack_public_path__ + "static/media/settings.7dcf64c8.svg";